/**
* 财务管理 已开发票
*/
<template>
  <div class="contianer">
    <!-- 面包屑导航 -->
    <!-- <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>财务管理</el-breadcrumb-item>
        <el-breadcrumb-item>已开发票</el-breadcrumb-item>
      </el-breadcrumb>
    </div> -->
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="">
        <el-date-picker
          v-model="formInline.Date"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.order_code" clearable placeholder="输入订单编号"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.invoice_code" clearable placeholder="输入发票号"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.invoice_title" clearable placeholder="输入发票抬头"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="formInline.invoice_type" placeholder="请选择发票类型" clearable>
          <el-option label="增值税专用发票" value="182"></el-option>
          <el-option label="增值税普通发票（电子发票）" value="181"></el-option>
          <el-option label="增值税普通发票（纸质发票）" value="180"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="search">查询</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <div style="height: 510px;overflow-y: auto">
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                :span-method="ObjectSpanMethod" @cell-dblclick="cellDbClick"
                element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column align="center" type="selection" width="60">
        </el-table-column>
        <el-table-column
          label="序号"
          width="60">
          <template slot-scope="scope">
            {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="开票时间" width="135">
        </el-table-column>
        <el-table-column prop="invoice_code" label="发票号" width="120" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="invoice_no" label="发票代号" width="120" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="invoice_title" label="发票抬头" min-width="180" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="invoice_money" label="开票金额" width="100">
          <template slot-scope="scope">
            <div>￥{{scope.row.invoice_money}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="tax_rate" label="税率" width="60">
          <template slot-scope="scope">
            <div>{{parseInt((scope.row.tax_rate)*100)}}%</div>
          </template>
        </el-table-column>
        <el-table-column prop="no_tax_money" label="未税金额" width="100">
          <template slot-scope="scope">
            <div>￥{{scope.row.no_tax_money}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="tax_money" label="税额" width="100">
          <template slot-scope="scope">
            <div>￥{{scope.row.tax_money}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="invoice_type" label="发票类型" width="180">
          <template slot-scope="scope">
            <div v-if="scope.row.invoice_type=='182'">增值税专用发票</div>
            <div v-else-if="scope.row.invoice_type=='181'">增值税普通发票（电子发票）</div>
            <div v-else>增值税普通发票（纸质发票）</div>
          </template>
        </el-table-column>
        <el-table-column prop="order_code" label="订单编号" width="135">
        </el-table-column>
        <el-table-column prop="settle_amount" label="订单金额" width="100">
          <template slot-scope="scope">
            <div>￥{{scope.row.settle_amount}}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" min-width="220">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" v-if="scope.row.delivery_no"
                       @click="logistics(scope.row.delivery_no,scope.row.delivery_name)">物流信息
            </el-button>
            <el-button type="success" size="mini" v-if="scope.row.pdfurl" @click="lookInvoice(scope.row.pdfurl)">查看发票
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog title="物流信息" :close-on-click-modal="false" :close-on-press-escape="false"
               :visible.sync="logisticsVisible" width="50%" center>
      <div class="delivery"><span class="color333">{{tableData.delivery_company_name}}</span><span
        class="delivery_text color333">快递单号</span><span class="color666">{{tableData.delivery_no}}</span></div>
      <el-table
        :data="tableData.logs" :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
        style="width: 100%">
        <el-table-column
          prop="create_time"
          label="时间"
          width="180">
        </el-table-column>
        <el-table-column
          prop="log"
          label="内容">
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
  import {invoiceList, invoiceDeliveryLog} from '../../api/basisMG'
  import Pagination from '../../components/Pagination'
  import {timestampToDate} from "../../utils/util";

  export default {
    data: () => {
      return {
        loading: false, //是显示加载
        logisticsVisible: false, //控制页面显示与隐藏
        formInline: {
          page: 1,
          rows: 10,
          Date: '',
          order_code: '',
          invoice_code: '',
          invoice_title: '',
          invoice_type: '',
          begin_time: "",
          end_time: ""
        },
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        tableData: {}
      }
    },
    // 注册组件
    components: {
      Pagination
    },

    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 获取公司列表
      getdata(parameter) {
        this.loading = true
        invoiceList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData = res.content.rows
              // 分页赋值
              this.pageparm.currentPage = this.formInline.page
              this.pageparm.pageSize = this.formInline.rows
              this.pageparm.total = res.content.total
              this.getSpanArr(this.listData)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.rows = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        if (this.formInline.Date) {
          this.formInline.begin_time = timestampToDate(this.formInline.Date[0])
          this.formInline.end_time = timestampToDate(this.formInline.Date[1])
        } else {
          this.formInline.begin_time = ''
          this.formInline.end_time = ''
        }
        this.formInline.page = 1;
        this.getdata(this.formInline)
      },
      //双击复制
      cellDbClick(row, column, cell, event) {
        if (row.invoice_code == cell.innerText || row.invoice_title == cell.innerText||row.order_code == cell.innerText) {
          if (event.type === "dblclick") {
            var save = function (e) {
              e.clipboardData.setData('text/plain', cell.innerText);
              e.preventDefault();//阻止默认行为
            }
            document.addEventListener('copy', save);
            document.execCommand("copy");
            document.removeEventListener('copy', save);
          }
          this.$message({message: '复制成功', type: 'success'})
        }
      },
      //显示物流界面
      logistics: function (delivery_no, delivery_name) {
        this.logisticsVisible = true
        invoiceDeliveryLog(delivery_no, delivery_name)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.tableData = res.content || '';
            }
          })
          .catch(err => {
            this.loading = false
            // this.$message.error('网络错误，请稍后再试！')
          })
      },
      lookInvoice(pdfurl) {
        window.open(pdfurl)
      },
      // 处理要合并相同行的列
      getSpanArr(data) {
        this.spanCreateTimeArr = []
        this.spanInvoiceCodeArr = []
        this.spanInvoiceNoArr = []
        this.spanInvoiceTitleArr = []
        this.spanInvoiceMoneyArr = []
        this.spanTaxRateArr = []
        this.spanNoTaxMoneyArr = []
        this.spanTaxMoneyArr = []
        this.spanInvoiceTypeArr = []
        this.spanOperateArr = []
        for (var i = 0; i < data.length; i++) {
          if (i === 0) {
            // 如果是第一条记录（即索引是0的时候），向数组中加入１
            this.spanCreateTimeArr.push(1)
            this.spanInvoiceCodeArr.push(1)
            this.spanInvoiceNoArr.push(1)
            this.spanInvoiceTitleArr.push(1)
            this.spanInvoiceMoneyArr.push(1);
            this.spanTaxRateArr.push(1)
            this.spanNoTaxMoneyArr.push(1)
            this.spanTaxMoneyArr.push(1)
            this.spanInvoiceTypeArr.push(1);
            this.spanOperateArr.push(1);
            this.timepos = 0
            this.pos = 0
            this.codePos = 0
            this.proxyPos = 0
            this.moneyPos = 0
            this.taxratepos = 0
            this.notaxmoneycodePos = 0
            this.taxmoneyPos = 0
            this.invoicetypePos = 0
            this.operatePos = 0
          } else {
            if (data[i].create_time === data[i - 1].create_time && data[i].invoice_code === data[i - 1].invoice_code) {
              // 如果proxy_name 相等就累加，并且push 0
              this.spanCreateTimeArr[this.timepos] += 1
              this.spanCreateTimeArr.push(0)
            } else {
              // 不相等push 1
              this.spanCreateTimeArr.push(1)
              this.timepos = i
            }
            if (data[i].invoice_code === data[i - 1].invoice_code) {
              // 如果proxy_id 相等就累加，并且push 0
              this.spanInvoiceCodeArr[this.pos] += 1
              this.spanInvoiceCodeArr.push(0)
            } else {
              // 不相等push 1,并且可修改下标指向
              this.spanInvoiceCodeArr.push(1)
              this.pos = i
            }
            // 相同机构名称
            if (data[i].invoice_no === data[i - 1].invoice_no && data[i].invoice_code === data[i - 1].invoice_code) {
              // 如果proxy_name 相等就累加，并且push 0
              this.spanInvoiceNoArr[this.codePos] += 1
              this.spanInvoiceNoArr.push(0)
            } else {
              // 不相等push 1
              this.spanInvoiceNoArr.push(1)
              this.codePos = i
            }
            // 相同机构归属
            if (data[i].invoice_title === data[i - 1].invoice_title && data[i].invoice_code === data[i - 1].invoice_code) {
              // 如果proxy 相等就累加，并且push 0
              this.spanInvoiceTitleArr[this.proxyPos] += 1
              this.spanInvoiceTitleArr.push(0)
            } else {
              // 不相等push 1
              this.spanInvoiceTitleArr.push(1)
              this.proxyPos = i
            }
            // 相同机构归属
            if (data[i].invoice_money === data[i - 1].invoice_money && data[i].invoice_code === data[i - 1].invoice_code) {
              // 如果proxy 相等就累加，并且push 0
              this.spanInvoiceMoneyArr[this.moneyPos] += 1
              this.spanInvoiceMoneyArr.push(0)
            } else {
              // 不相等push 1
              this.spanInvoiceMoneyArr.push(1)
              this.moneyPos = i
            }
            if (data[i].tax_rate === data[i - 1].tax_rate && data[i].invoice_code === data[i - 1].invoice_code) {
              // 如果proxy_id 相等就累加，并且push 0
              this.spanTaxRateArr[this.taxratepos] += 1
              this.spanTaxRateArr.push(0)
            } else {
              // 不相等push 1,并且可修改下标指向
              this.spanTaxRateArr.push(1)
              this.taxratepos = i
            }
            // 相同机构名称
            if (data[i].no_tax_money === data[i - 1].no_tax_money && data[i].invoice_code === data[i - 1].invoice_code) {
              // 如果proxy_name 相等就累加，并且push 0
              this.spanNoTaxMoneyArr[this.notaxmoneycodePos] += 1
              this.spanNoTaxMoneyArr.push(0)
            } else {
              // 不相等push 1
              this.spanNoTaxMoneyArr.push(1)
              this.notaxmoneycodePos = i
            }
            // 相同机构归属
            if (data[i].tax_money === data[i - 1].tax_money && data[i].invoice_code === data[i - 1].invoice_code) {
              // 如果proxy 相等就累加，并且push 0
              this.spanTaxMoneyArr[this.taxmoneyPos] += 1
              this.spanTaxMoneyArr.push(0)
            } else {
              // 不相等push 1
              this.spanTaxMoneyArr.push(1)
              this.taxmoneyPos = i
            }
            // 相同机构归属
            if (data[i].invoice_Type === data[i - 1].invoice_Type && data[i].invoice_code === data[i - 1].invoice_code) {
              // 如果proxy 相等就累加，并且push 0
              this.spanInvoiceTypeArr[this.invoicetypePos] += 1
              this.spanInvoiceTypeArr.push(0)
            } else {
              // 不相等push 1
              this.spanInvoiceTypeArr.push(1)
              this.invoicetypePos = i
            }
            // 相同机构归属
            if (data[i].invoice_code === data[i - 1].invoice_code) {
              // 如果proxy 相等就累加，并且push 0
              this.spanOperateArr[this.operatePos] += 1
              this.spanOperateArr.push(0)
            } else {
              // 不相等push 1
              this.spanOperateArr.push(1)
              this.operatePos = i
            }
          }
        }
      },
      ObjectSpanMethod({row, column, rowIndex, columnIndex}) {
        // 合并相同列数据的行
        if (columnIndex == 2 && rowIndex !== this.tableData.length - 1) {
          const _row = this.spanCreateTimeArr[rowIndex]
          const _col = _row > 0 ? 1 : 0
          return {
            rowspan: _row,
            colspan: _col
          }
        }
        // 合并相同列数据的行
        if (columnIndex == 3 && rowIndex !== this.tableData.length - 1) {
          const _row = this.spanInvoiceCodeArr[rowIndex]
          const _col = _row > 0 ? 1 : 0
          return {
            rowspan: _row,
            colspan: _col
          }
        }
        // 合并相同列数据的行
        if (columnIndex == 4 && rowIndex !== this.tableData.length - 1) {
          const _row = this.spanInvoiceNoArr[rowIndex]
          const _col = _row > 0 ? 1 : 0
          return {
            rowspan: _row,
            colspan: _col
          }
        }
        // 合并相同列数据的行
        if (columnIndex == 5 && rowIndex !== this.tableData.length - 1) {
          const _row = this.spanInvoiceTitleArr[rowIndex]
          const _col = _row > 0 ? 1 : 0
          return {
            rowspan: _row,
            colspan: _col
          }
        }
        // 合并相同列数据的行
        if (columnIndex == 6 && rowIndex !== this.tableData.length - 1) {
          const _row = this.spanInvoiceMoneyArr[rowIndex]
          const _col = _row > 0 ? 1 : 0
          return {
            rowspan: _row,
            colspan: _col
          }
        }
        // 合并相同列数据的行
        if (columnIndex == 7 && rowIndex !== this.tableData.length - 1) {
          const _row = this.spanTaxRateArr[rowIndex]
          const _col = _row > 0 ? 1 : 0
          return {
            rowspan: _row,
            colspan: _col
          }
        }
        // 合并相同列数据的行
        if (columnIndex == 8 && rowIndex !== this.tableData.length - 1) {
          const _row = this.spanNoTaxMoneyArr[rowIndex]
          const _col = _row > 0 ? 1 : 0
          return {
            rowspan: _row,
            colspan: _col
          }
        }
        // 合并相同列数据的行
        if (columnIndex == 9 && rowIndex !== this.tableData.length - 1) {
          const _row = this.spanTaxMoneyArr[rowIndex]
          const _col = _row > 0 ? 1 : 0
          return {
            rowspan: _row,
            colspan: _col
          }
        }
        // 合并相同列数据的行
        if (columnIndex == 10 && rowIndex !== this.tableData.length - 1) {
          const _row = this.spanInvoiceTypeArr[rowIndex]
          const _col = _row > 0 ? 1 : 0
          return {
            rowspan: _row,
            colspan: _col
          }
        }
        // 合并相同列数据的行
        if (columnIndex == 13 && rowIndex !== this.tableData.length - 1) {
          const _row = this.spanOperateArr[rowIndex]
          const _col = _row > 0 ? 1 : 0
          return {
            rowspan: _row,
            colspan: _col
          }
        }
        // 将最后一行进行合并列弄成总计
        if (rowIndex == this.tableData.length - 1 && columnIndex == 0) {
          return [1, 4]
        }
        // 把第二列、第三列、第四列的列改为0（不占列）
        if (rowIndex == this.tableData.length - 1 && (columnIndex == 1 || columnIndex == 2 || columnIndex == 3)) {
          return [0, 0]
        }
      }
    }
  }
</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  .breadcrumb {
    margin-bottom: 15px;
  }

  /deep/ .user-search .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  /deep/ .user-search .el-form-item {
    margin-bottom: 10px;
  }

  /deep/ .user-search .el-button--small {
    height: 40px;
  }

  .color333 {
    color: #333333;
  }

  .color666 {
    color: #666666;
  }

  .userRole {
    width: 100%;
  }

  .delivery {
    margin-bottom: 10px;
    text-align: center;
  }

  .delivery_text {
    margin-left: 20px;
    margin-right: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/views/finance/Invoice.vue